import React, { Component, Fragment } from 'react';
import numeral from 'numeral';
import moment from 'moment';
import Button from '@material-ui/core/Button';
import DefaultModal from 'Modals/DefaultModal';
import getErrorsFromResponse from 'Components/Forms/Functions/getErrorsFromResponse';
import getFormStatus from 'Components/Forms/Functions/getFormStatus';
import Loader from 'Pure/Loader';
import PDFIcon from 'Icons/PDFIcon';
import bemit from 'Functions/bemit';
import { action, URL } from 'Shared/Routes';
export default class AdminPackOrderRow extends Component {
  state = {
    loading: false,
    modal: false
  };
  modal_ref = React.createRef();
  openModal = e => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      modal: true,
      modal_trigger: e?.target
    });
  };
  closeModal = e => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      modal: false,
      modal_trigger: undefined
    });
  };
  validateOrderForm = e => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post(action('validateOrderForm'), {
      id: props.data?.id
    }).then(function (xhr, response) {
      component.setState({
        loading: false
      });
      props.requestUpdate();
      component.modal_ref?.current?.click();
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const {
      data,
      blank = false,
      fields
    } = props;
    numeral.locale('en');
    moment.locale('fr');
    const loader = state.loading === true ? /*#__PURE__*/React.createElement(Loader, {
      className: "c-loader",
      bemit: ['white', 'bg-red']
    }) : undefined;
    let output = /*#__PURE__*/React.createElement("div", {
      className: 'c-dashboard__row '
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell"
    }, data.payment_status !== 'paid' && data.payment_type === 'order_form' ? data?.text_number_order_form : data?.text_number), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell PackOrder-date"
    }, data.company.name), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell PackOrder-date"
    }, moment(data.created_at).format("DD/MM/YYYY")), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell PackOrder-date"
    }, data?.payment_capture?.Date ? moment(data.payment_capture.Date).format("DD/MM/YYYY") : undefined), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell CustomerPackOrder-login"
    }, data.total_amount_ttc + '€'), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell PackOrder-hours"
    }, data.payment_type === "card" ? "Carte bancaire" : "Bon de commande"), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell PackOrder-amount"
    }, data.payment_status === "paid" ? "Payée" : "En attente"), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell CustomerPackOrderIndex-login"
    }, /*#__PURE__*/React.createElement("a", {
      href: action('getPackOrderIndexPDF').replace(':packorder_id', data.id),
      target: "_blank",
      type: "application/pdf",
      rel: "noopener noreferrer",
      className: "c-dashboard__pdf-link"
    }, /*#__PURE__*/React.createElement(PDFIcon, {
      className: "c-dashboard__pdf-icon"
    }))), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell"
    }, data.payment_status !== 'paid' && data.payment_type === 'order_form' ? /*#__PURE__*/React.createElement(Button, {
      className: bemit('c-flat-btn', ['primary', 'small']),
      onClick: component.openModal
    }, "Valider le bon de commande") : undefined), /*#__PURE__*/React.createElement(DefaultModal, {
      open: state.modal,
      title: "Validation d'un bon de commande",
      trigger_src: state.modal_trigger,
      "close-ref": component.modal_ref,
      "with-footer-close": false,
      "hide-controls": true,
      bemit: ['default', 'small'],
      onClose: component.closeModal
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-message c-message--orange"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-message__content"
    }, "Voulez-vous valider ce bon de commande ?")), getFormStatus(state), /*#__PURE__*/React.createElement("div", {
      className: "c-modal__controls"
    }, /*#__PURE__*/React.createElement(Button, {
      color: "primary",
      className: "c-flat-btn c-flat-btn--red u-margin-right-25",
      onClick: component.validateOrderForm
    }, loader, "Oui, Valider"), /*#__PURE__*/React.createElement(Button, {
      color: "primary",
      className: "c-flat-btn",
      onClick: e => component.modal_ref?.current?.click()
    }, "Fermer"))));
    return output;
  }
}
